// Native & external imports
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule  } from '@angular/router';
// Modules
import { SharedUiComponentsModule } from 'src/modules/shared-ui-components/shared-ui-components.module';
import { TopNavbarModule } from 'src/modules/top-navbar/top-navbar.module';
import { AlertModule } from 'src/modules/alert/alert.module';

// Components
import { LayoutComponent } from './layout/layout.component';
import { CmpSharedModule } from 'icamppro-shared-components';

// Pipes
import { LocalePipesModule } from 'src/pipes/localepipes.module';

// Export components
export { LayoutComponent } from './layout/layout.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from "lottie-web";
import { AlertComponent } from 'src/modules/alert/alert.component';
import { CmpSharedComponentsModule } from '@icamppro-customer-portal/shared/cmp-base';

function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    LayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TopNavbarModule,
    LocalePipesModule,
    CmpSharedModule,
    SharedUiComponentsModule,
    LottieComponent,
    AlertModule,
    CmpSharedComponentsModule,
  ],
  providers: [
    provideLottieOptions({ player: playerFactory }),
  ],
  exports: [
    LayoutComponent,
    AlertComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppLayoutModule { }
